<template>
  <div id="app"
       class="app-main">
    <v-header ref="header"
              :header-fixed="headerFixed" v-if="!isYF"></v-header>
    <router-view class="main-content" />
    <v-footer v-if="!isYF"></v-footer>
  </div>
</template>

<script>
import header from "@/components/header/header";
import footer from "@/components/footer/footer";
export default {
  name: "app",
  data () {
    return {
      headerFixed: false, // 固定导航(目前适用于移动端)
      isYF:true //是否亿飞申请页，不显示头脚
    };
  },
  mounted () {
    this.resetRem();
    window.addEventListener("scroll", this.handleScroll);
    // 友盟统计
    const s = document.createElement('script');
    s.src = 'https://s4.cnzz.com/z_stat.php?id=1279792272&web_id=1279792272';
    s.language = 'JavaScript';
    document.body.appendChild(s);
  },
  methods: {
    handleScroll () {
      if(!this.$refs.header){
        return
      }
      let headerClientHeight = this.$refs.header.clientHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= headerClientHeight) {
        this.headerFixed = true;
      } else {
        this.headerFixed = false;
      }
    }
  },
  components: {
    "v-header": header,
    "v-footer": footer
  },
  destroyed () {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  created(){
 
  },
  watch: {
    $route (to, from) {
      if(to.path.includes('/nofly')){
        this.isYF=true;
      }else{
        this.isYF=false;
      }
      document.documentElement.scrollTop = document.body.scrollTop = 0;
      // 友盟统计
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = '/';
        window._czc.push(['_trackPageview', contentUrl, refererUrl]);
      }
    }
  }
};
</script>

<style>
.app-main {
  height: 100%;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
}
.main-content {
  min-width: 1200px;
  margin: 0 auto;
}

@media all and (max-width: 768px) {
  .main-content {
    min-width: 100%;
  }
}

/* 滚动条的宽度(包括横向纵向) */
::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}
/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue